import React, { useState, useMemo } from "react";
import { Box, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ModeCommentOutlinedIcon from "@mui/icons-material/ModeCommentOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import DoDisturbOnOutlinedIcon from "@mui/icons-material/DoDisturbOnOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { INBOX_STATUS_OPTIONS, sumObj } from "../Inbox/Utilities/inboxUtils";

const STATUS_ICONS = {
  OPEN: ModeCommentOutlinedIcon,
  RESOLVED: CheckCircleOutlinedIcon,
  NO_RESPONSE_NEEDED: DoDisturbOnOutlinedIcon,
  HIDDEN: VisibilityOffOutlinedIcon,
};

export default function MessageStatus({
  selected,
  onChange,
  statusCounts,
  collapsed = false,
}) {
  const [localSelected, setLocalSelected] = useState(null);
  const active = selected !== undefined ? selected : localSelected;

  const selectStatus = (value) => {
    if (onChange) {
      onChange(value);
      return;
    }
    setLocalSelected(value);
  };

  const getStatusList = (statusCounts) => {
    const transformList = INBOX_STATUS_OPTIONS.map((option) => {
      const count = statusCounts?.[option.value] || 0;
      const icon = STATUS_ICONS[option.value];
      return { ...option, Icon: icon, count };
    });

    const totalCount = statusCounts ? sumObj(statusCounts) : 0;

    return [
      { value: null, Icon: MenuIcon, label: "All messages", count: totalCount },
      ...transformList,
    ];
  };

  const statusList = useMemo(() => getStatusList(statusCounts), [statusCounts]);

  return (
    <Box sx={{ borderTop: "1px solid rgb(241, 237, 230)", py: "10px" }}>
      {statusList.map(({ value, label, Icon, count }) => {
        const isActive = active === value;

        if (collapsed) {
          return (
            <Button
              sx={{
                ...styles.btn,
                ...styles.btnCollapsed,
                ...(isActive ? styles.selected : {}),
              }}
              key={label}
              onClick={() => selectStatus(value)}
              title={label}
              aria-label={label}
            >
              <Icon sx={{ fontSize: "18px" }} />
            </Button>
          );
        }

        return (
          <Button
            sx={{ ...styles.btn, ...(isActive ? styles.selected : {}) }}
            key={label}
            onClick={() => selectStatus(value)}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Icon sx={{ fontSize: "18px" }} />
              <Box>{label}</Box>
            </Box>

            <Box>
              <Box
                sx={{
                  ...styles.badge,
                  ...(isActive ? styles.badgeSelected : {}),
                }}
              >
                {count}
              </Box>
            </Box>
          </Button>
        );
      })}
    </Box>
  );
}

const styles = {
  btn: {
    fontFamily: "FustatSemiBold",
    color: "#5c6656",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    borderRadius: "10px",
    textTransform: "none",
    height: "40px",
  },
  btnCollapsed: {
    justifyContent: "center",
    minWidth: 0,
    width: "36px",
    height: "36px",
    padding: 0,
  },
  badge: {
    display: "flex",
    width: "fit-content",
    minWidth: "18px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "10px",
    bgcolor: "#f0ece5",
    px: "8px",
    py: "4px",
    fontFamily: "FustatSemiBold",
    fontSize: "12px",
    lineHeight: 1,
    color: "#12321f",
  },
  selected: {
    backgroundColor: "#f4f1ea",
    color: "#12321f",
  },
  badgeSelected: {
    backgroundColor: "#12321f",
    color: "#FFFFFF",
  },
};
